import { render, staticRenderFns } from "./TransferDialog.vue?vue&type=template&id=bf4cdf40&"
import script from "./TransferDialog.vue?vue&type=script&lang=js&"
export * from "./TransferDialog.vue?vue&type=script&lang=js&"
import style0 from "./TransferDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports